import { twMerge } from "tailwind-merge";
import React, { forwardRef } from "react";

const Container = forwardRef(({ children, className = "", ...rest }, ref) => {
  return (
    <div ref={ref} className={twMerge("px-4 py-3", className)} {...rest}>
      {children}
    </div>
  );
});

export default Container;
